import React from 'react';
import { Button, withStyles } from '@material-ui/core';
import styles from './CalculatorDialog.styles';
import { ICalculatorDialogProps } from './CalculatorDialog.properties';
import FormViewModal from 'components/common/Modals/FormViewModal';
import { IActionItem } from 'components/common/Modals/FormViewModal.properties';
import FormView from 'components/FormView';
import DoneAllIcon from '@markinson/uicomponents-v2/SvgIcons/DoneAll';
import SummaryTable from 'components/common/SummaryTable';
import FocusLock from 'react-focus-lock';

const CalculatorDialog = (props: ICalculatorDialogProps) => {
  const { open, onClose, onOk, classes, initialValues, values, formSchema, summaryTableSchema, summaryTableData, onCalculate, valuesSchema, isCalculateDisabled = false, dialogTitle = 'Calculator', dialogStyles } = props;

  const confirmationActions = (): IActionItem[] => {

    return [
      {
        title: 'Ok',
        isDefault: true,
        listener: () => {
          if (onOk) {
            onOk(values);
          }
        }
      },
      {
        title: 'Cancel',
        listener: () => {
          onClose();
        }
      }
    ];
  };

  const onCalculateHandler = () => {
    onCalculate(values);
  };

  function getModalContent(): JSX.Element {

    return (
      <div className={classes.formContainer}>
        <div className={summaryTableSchema ? classes.leftContainer : classes.leftContainerWOSummary}>
          <FormView
            isModal={true}
            isLoading={false}
            formName={'CalculatorDialogForm'}
            schema={formSchema}
            includeTabsHeight={true}
            initialValues={initialValues}
            valuesSchema={valuesSchema}
            operationMode={'EDIT'}
          />
          <div className={classes.calculatorFooter}>
            <Button
              variant={'contained'}
              className={classes.calculateButton}
              disabled={isCalculateDisabled}
              onClick={onCalculateHandler}>
              <DoneAllIcon style={{ color: !isCalculateDisabled ? '#006633' : 'rgba(0, 0, 0, 0.26)' }} /> CALCULATE
            </Button>
          </div>
        </div>
        {
          summaryTableSchema &&
          <div className={classes.rightContainer}>
            <SummaryTable
              loading={false}
              data={summaryTableSchema}
              calculatorSummary={summaryTableData}
            />
          </div>
        }
      </div >
    );
  }

  return (
    <>
      <FocusLock className={classes.focusOuter} autoFocus={false}>
        <FormViewModal
          open={open}
          dialogStyles={dialogStyles}
          loading={false}
          title={dialogTitle}
          dialogActionsButtons={true}
          dialogActionsShadow={false}
          modalContent={getModalContent()}
          actions={confirmationActions()}
        />
      </FocusLock>
    </>
  );
};

export default withStyles(styles, { index: 1 })(CalculatorDialog);
